import { render, staticRenderFns } from "./confirm-dialog-body.vue?vue&type=template&id=264f4186&scoped=true"
import script from "./confirm-dialog-body.vue?vue&type=script&lang=js"
export * from "./confirm-dialog-body.vue?vue&type=script&lang=js"
import style0 from "./confirm-dialog-body.vue?vue&type=style&index=0&id=264f4186&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264f4186",
  null
  
)

export default component.exports